import {
  DATASOURCE_CATEGORY_PREFIXES_BY_TYPE,
  DATASOURCE_TYPES,
} from '@monoimin/constants';
import { Locales } from '@monoimin/sb-types';

const datasources = {
  categories: {
    ru: () =>
      import(`./datasources/categories/ru.json`).then(
        (module) => module.default
      ),
    en: () =>
      import(`./datasources/categories/en.json`).then(
        (module) => module.default
      ),
    de: () =>
      import(`./datasources/categories/de.json`).then(
        (module) => module.default
      ),
    tr: () =>
      import(`./datasources/categories/tr.json`).then(
        (module) => module.default
      ),
    es: () =>
      import(`./datasources/categories/es.json`).then(
        (module) => module.default
      ),
  },
};

export interface DataSourceCategory {
  id: number;
  name: string;
  value: string;
  type: string;
  dimension_value: string;
}

export async function getCategoriesDatasource(
  locale: Locales = 'en',
  type?: DATASOURCE_TYPES
): Promise<DataSourceCategory[]> {
  const sourceByType = datasources['categories'];

  if (!sourceByType[locale]) {
    locale = 'en';
  }

  const categories = await sourceByType[locale]();

  if (type) {
    return categories.filter((item) => item.type === type);
  }

  return categories;
}

export const getCountriesDatasource = () =>
  import(`./datasources/countries.json`).then((module) => module.default);

export const normalizeDatasourseCategoryValue = (
  value: string,
  type: DATASOURCE_TYPES
) => {
  return value.replace(`${type}-`, '');
};

export const normalizeDatasourseCategoryName = (
  name: string,
  type: DATASOURCE_TYPES
) => {
  const prefix = DATASOURCE_CATEGORY_PREFIXES_BY_TYPE[type];

  return name.replace(prefix, '').trim();
};

export const getDiclensionDatasource = async () => {
  return import(`../lib/datasources/diclensions.json`).then(
    (module) => module.default
  );
};
